const H1 = ({ children }) => {
    return (
        <h1 className="text-yellow-amnesty mb-0 sm:mb-10 text-4xl sm:text-5xl font-bold">
            {children}
        </h1>
    )
}

export default H1;